import { forEach } from 'lodash';
import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { mapRawCryptaSegmentsToSegmentsGroup } from '../../service/CryptaHelpers/CryptaHelpers';
import { getSegmentsIds, getSegmentsTree } from '../../service/InterestsEditorHelpers/InterestsEditorHelpers';
import { CryptaSegment, CryptaSegmentsByType } from '../../typings/cryptaSegments';
import { WebGoalType } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

export const getAllCryptaSegmentsByType = createSelector(
    (state: State) => state.commonData.cryptaSegments,
    cryptaSegments => {
        return cryptaSegments.reduce((segmentsByType: CryptaSegmentsByType, segment: CryptaSegment) => {
            if (!segmentsByType[segment.type]) {
                segmentsByType[segment.type] = [];
            }

            segmentsByType[segment.type].push(segment);

            return segmentsByType;
        }, {});
    }
);

export const getCryptaSegmentsByType = createCachedSelector(
    (state: State, goalType: WebGoalType) => getAllCryptaSegmentsByType(state)[goalType],
    segments => {
        return mapRawCryptaSegmentsToSegmentsGroup(segments);
    }
)((state: State, goalType: WebGoalType) => goalType);

export const getInterestsIdsAndTree = createSelector(
    (state: State) => getAllCryptaSegmentsByType(state)[WebGoalType.interests],
    (interestsSegments: CryptaSegment[]) => {
        return {
            interestsIds: getSegmentsIds(interestsSegments),
            interestsTree: getSegmentsTree(interestsSegments)
        };
    }
);

export const getAllSegmentsGroupByType = createSelector(
    (state: State) => getAllCryptaSegmentsByType(state),
    (allCryptaSegments: CryptaSegmentsByType) => {
        const result: CryptaSegmentsByType = {};

        forEach(allCryptaSegments, (cryptaSegment: CryptaSegment[], type: WebGoalType) => {
            result[type] = mapRawCryptaSegmentsToSegmentsGroup(cryptaSegment);
        });

        return result;
    }
);

export const getInterestsIds = createSelector(
    (state: State) => getAllCryptaSegmentsByType(state)[WebGoalType.interests],
    (interestsSegments: CryptaSegment[]) => {
        return getSegmentsIds(interestsSegments);
    }
);
